import { Breakpoints } from "../theme/types";

export const getBreakpoint = (size: string): string => {
  return `@media only screen and (max-width: ${size})`;
};
